export enum UserInteraction {
  SITE_CLICK = 'site_click',
  PHONE_CLICK = 'phone_click',
  CARD_CLICK = 'card_click'
}
